import moment from 'moment-timezone';

export const DEFAULT_TIMESTAMP_FORMAT = 'MMM D, YYYY [at] h:mm:ss a (z)';

export function formatWithTimezone(timestamp?: number, timezone?: string) {
  if (timestamp == null || Number.isNaN(timestamp) || timestamp === 0 || timezone == null || timezone === '') {
    return null;
  }

  return moment.unix(timestamp).tz(timezone).format(DEFAULT_TIMESTAMP_FORMAT);
}
